import { render, staticRenderFns } from "./UserAttributeFilters.vue?vue&type=template&id=0b830f00&"
import script from "./UserAttributeFilters.vue?vue&type=script&lang=js&"
export * from "./UserAttributeFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports